import "../../App.css";
import "../../styles/tabStyle.css";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import AutocompleteForms from "../AutocompleteForms";
import React, { useState, useEffect } from "react";
import Parametros from "../Parametros";
import Modal from "react-modal";
import CurrentUser from "../CurrentUser";

function CrearCausa(props) {
  const { history } = props;
  const [listTribunales, setTribunales] = useState(props.listTribunales);
  // eslint-disable-next-line
  const [tipoState, setTipos] = useState(props.tipoState);
  const [courtRole, setCourtRole] = useState(props.courtRole);

  const [deudores, setDeidpres] = useState(props.deudores);
  const [acreedores, setAcreedpres] = useState(props.acreedores);

  // eslint-disable-next-line
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [usuario, setUsuarioDev] = useState(CurrentUser.user);
  const [monedas, setMonedas] = useState([]);
  const [concepts, setConcepts] = useState([]);
  const [portfolios, setPortfolios] = useState([]);
  const [formulario, setFormulario] = useState({
    collproc_type: null,
    n_operation: null,
    strategy: null,
    court: null,
    role: null,
    legalprocessid: null,
    acreedor: null,
    deudor: null,
    date: null,
    amount: null,
    currency_id: null,
    concept: null,
    period: null,
    description: null,
    portfolio: null,
  });
  useEffect(() => {
    fetch(Parametros.urlApi + "Currency", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Error al cargar monedas");
        return response.json();
      })
      .then((data) => setMonedas(data))
      .catch((error) => {
        console.error(error);
        alert("Error al cargar monedas: " + error.message);
      });
    fetch(Parametros.urlApi + "debt_concepts", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Error al cargar conceptos");
        return response.json();
      })
      .then((data) => setConcepts(data))
      .catch((error) => {
        console.error(error);
        alert("Error al cargar conceptos: " + error.message);
      });
  }, []);

  useEffect(() => {
    fetch(Parametros.urlApi + "portfolios?skip=0&limit=1000", {
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al cargar carteras");
        return res.json();
      })
      .then((data) => setPortfolios(data))
      .catch((error) => {
        console.error(error);
        alert("Error al cargar carteras: " + error.message);
      });
  }, [usuario]);

  const handleInputChange = (e, algo) => {
    const value = e.target.value ? e.target.value : e.currentTarget.innerText;
    const name = e.target.getAttribute("name");

    setFormulario({
      ...formulario,
      [name]: value,
    });
  };

  let crearCausa = (event, objetoBusqueda) => {
    if (event) {
      event.preventDefault();
    }

    let formularioFinal = formulario;

    const requiredKeys = [
      { key: "collproc_type", value: "Tipo de Causa" },
      { key: "n_operation", value: "N° Operacion" },
      { key: "portfolio", value: "Cartera" },
      { key: "legalprocessid", value: "Rol de la causa" },
      { key: "date", value: "Fecha" },
      { key: "period", value: "Periodo" },
      { key: "deudor", value: "Deudor" },
      { key: "concept", value: "Concepto Deuda" },
      { key: "description", value: "Descripción" },
      { key: "currency_id", value: "Moneda" },
      { key: "acreedor", value: "Acreedor" },
    ];

    for (const key of requiredKeys) {
      if (!formularioFinal[key.key]) {
        alert(`El campo "${key.value}" es obligatorio`);
        return;
      }
    }

    let formToSend = {
      collproc_type: formularioFinal.collproc_type,
      n_operation: formularioFinal.n_operation,
      strategy: formularioFinal.strategy,
      court: formularioFinal.court,
      role: formularioFinal.role,
      legalprocessid: formularioFinal.legalprocessid,
      amount: formularioFinal.amount,
      date: formularioFinal.date,
      period: formularioFinal.period,
      creditor: formularioFinal.acreedor,
      debtor: formularioFinal.deudor,
      concept: formularioFinal.concept,
      description: formularioFinal.description,
      currency_id: formularioFinal.currency_id,
      portfolio: formularioFinal.portfolio,
    };

    tipoState.map((item) => {
      if (item.name === formToSend.collproc_type) {
        formToSend.collproc_type = item.coll_proc_type_id;
      }
      return item;
    });
    listTribunales.map((item) => {
      if (item.name === formToSend.court) {
        formToSend.court = item.court_id;
      }
      return item;
    });
    courtRole.map((item) => {
      if (item.name === formToSend.role) {
        formToSend.role = item.court_role_id;
      }
      return item;
    });
    //
    //

    let status = 0;
    fetch(Parametros.post + "coll_proc", {
      method: "POST",

      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
      body: JSON.stringify(formToSend),
    })
      .then((response) => {
        status = response.status;
        return response.json();
      })
      .then((data) => {
        if (status === 200) {
          alert("Se agrego correctamente");

          // alert(data.detail)

          setUpdate(!update);
        } else if (status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else if (status === 422) {
          alert("fallo al agregar");
        } else {
          alert(data.detail);
        }
      })
      .catch((error) => {
        console.error(error);
        alert("Error al crear causa: " + error.message);
      });

    document.getElementById("formularioBusqueda")?.reset();

    setFormulario({});
    props.setModal(!props.modalState);
  };
  const customStyles = {
    overlay: {
      zIndex: "4",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "50%",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const [update, setUpdate] = useState(false);

  return (
    <div>
      <Modal
        isOpen={props.modalState}
        contentLabel="Example Modal"
        ariaHideApp={false}
        style={customStyles}
        onRequestClose={props.modalCondig}
      >
        <form id="formularioBusqueda">
          <div className="col-md-12">
            <div className="col-md-4">
              <h5>Periodo</h5>
              <input
                onChange={handleInputChange}
                name={"period"}
                className="form-control"
              ></input>
            </div>
            <div className="col-md-4">
              <h5>Descripción</h5>
              <input
                onChange={handleInputChange}
                name={"description"}
                className="form-control"
              ></input>
            </div>
            <div className="col-md-4">
              <h5>Fecha</h5>
              <input
                onChange={handleInputChange}
                type={"date"}
                value={formulario.date}
                name={"date"}
                className="form-control"
              ></input>
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-4">
              <h5>Moneda</h5>
              <AutocompleteForms
                nameElement={"currency_id"}
                formularioBuscado={formulario}
                setformulario={setFormulario}
                formularioUpdate={formulario}
                setformularioUpdate={setFormulario}
                personalHandleChange={handleInputChange}
                value={formulario.currency_id}
                suggestions={monedas.map((item) => {
                  return {
                    value: item.currency_id,
                    label: item.isocode,
                  };
                })}
              />
            </div>
            <div className="col-md-4">
              <h5>Concepto Deuda</h5>
              <AutocompleteForms
                nameElement={"concept"}
                formularioBuscado={formulario}
                setformulario={setFormulario}
                formularioUpdate={formulario}
                setformularioUpdate={setFormulario}
                personalHandleChange={handleInputChange}
                value={formulario.concept}
                suggestions={concepts.map((item) => {
                  return {
                    value: item.debt_concept_id,
                    label: item.name,
                  };
                })}
              />
            </div>
            <div className="col-md-4">
              <h5>N° Operacion</h5>
              <input
                onChange={handleInputChange}
                name={"n_operation"}
                className="form-control"
              ></input>
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-4">
              <h5>Estrategia</h5>
              <input
                onChange={handleInputChange}
                name={"strategy"}
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Rol de la causa</h5>
              <input
                onChange={handleInputChange}
                name={"legalprocessid"}
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Tipo de Causa</h5>
              <AutocompleteForms
                personalHandleChange={handleInputChange}
                nameElement={"collproc_type"}
                formularioBuscado={formulario}
                setformulario={setFormulario}
                key={update}
                value={formulario.collproc_type}
                suggestions={props.tipoState.map((item) => {
                  return { value: item.coll_proc_type_id, label: item.name };
                })}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-4">
              <h5>Tribunal</h5>
              <AutocompleteForms
                personalHandleChange={handleInputChange}
                nameElement={"court"}
                formularioBuscado={formulario}
                setformulario={setFormulario}
                key={update}
                value={formulario.court}
                suggestions={props.listTribunales.map((item) => {
                  return { value: item.court_id, label: item.name };
                })}
              />
            </div>

            <div className="col-md-4">
              <h5>Rol Tribunal</h5>
              <AutocompleteForms
                personalHandleChange={handleInputChange}
                nameElement={"role"}
                formularioBuscado={formulario}
                setformulario={setFormulario}
                key={update}
                value={formulario.role}
                suggestions={props.courtRole.map((item) => {
                  return { value: item.court_role_id, label: item.name };
                })}
              />
            </div>

            <div className="col-md-4">
              <h5>Acreedor</h5>
              <AutocompleteForms
                personalHandleChange={handleInputChange}
                nameElement={"acreedor"}
                formularioBuscado={formulario}
                setformulario={setFormulario}
                key={update}
                value={formulario.acreedor}
                suggestions={props.acreedores.map((item) => {
                  return {
                    value: item.rut,
                    label: item.name + "/" + item.rut,
                  };
                })}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-4">
              <h5>Deudor</h5>
              <AutocompleteForms
                personalHandleChange={handleInputChange}
                nameElement={"deudor"}
                formularioBuscado={formulario}
                setformulario={setFormulario}
                key={update}
                value={formulario.deudor}
                suggestions={props.deudores.map((item) => {
                  return {
                    value: item.value.split("/")[0].trim(),
                    label: item.value,
                  };
                })}
              />
            </div>

            <div className="col-md-4">
              <h5>Cartera</h5>
              <AutocompleteForms
                personalHandleChange={handleInputChange}
                nameElement={"portfolio"}
                formularioBuscado={formulario}
                setformulario={setFormulario}
                key={update}
                value={formulario.portfolio}
                suggestions={portfolios?.map((portfolio) => ({
                  value: portfolio.portfolio_id,
                  label: portfolio.name,
                }))}
              />
            </div>
          </div>

          <div className="col-md-12">
            <br />
            <button
              type="submit"
              onClick={(e) => {
                crearCausa(e);
              }}
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar
            </button>
          </div>
        </form>
      </Modal>
      <div className="col-md-4">
        <br />
        <button
          style={{ margin: "14px 0px" }}
          onClick={props.modalCondig}
          className="form-control button brEdit btn-primary"
        >
          Agregar
        </button>
      </div>
    </div>
  );
}

export default withRouter(CrearCausa);
